import { lazy, Suspense } from 'react';

import { QueryLoading } from '../QueryLoading';

const TestLink = lazy(() =>
  import('./TestLink').then(({ TestLink }) => ({
    default: TestLink,
  })),
);

export function LazyTestLink(): JSX.Element {
  return (
    <Suspense fallback={<QueryLoading isAbsolute />}>
      <TestLink />
    </Suspense>
  );
}
